import { projectsV2EditProjectMutation } from '@civilgrid/rest-client';
import { useMutation } from '@tanstack/react-query';

type UpdateProjectMutationOptions = ReturnType<typeof projectsV2EditProjectMutation>;

export function useUpdateProject(options?: Partial<UpdateProjectMutationOptions>) {
  return useMutation({ ...projectsV2EditProjectMutation(), ...options });
}
